import React from 'react';
import { ShieldCheckIcon } from 'lucide-react';
export function Guarantee() {
  return <section className="w-full bg-cream py-16 md:py-24" data-id="element-100" data-mp="1o3x1pk7r0m0y">
      <div className="mx-auto w-full max-w-narrow px-5 text-center md:px-8" data-id="element-101" data-mp="1o3dj01a9xtlv">
        <span className="mx-auto flex h-14 w-14 items-center justify-center rounded-full bg-white shadow-card" data-id="element-102" data-mp="2223lxxjryni5">
          <ShieldCheckIcon className="h-7 w-7 text-teal-500" aria-hidden="true" data-id="element-103" data-mp="1x54q9akgq8hu" />
        </span>

        <h2 className="mt-7 font-display text-[2.1rem] font-extrabold leading-tight tracking-tight text-plum-700 md:text-[2.7rem]" data-id="element-104" data-mp="19fahp576f63e">
          Garantía de <span className="italic text-gold-700" data-id="element-105" data-mp="1j4ahgqti65in">7 días</span>
        </h2>

        <div className="mx-auto mt-7 max-w-2xl space-y-4 text-lg leading-relaxed text-muted" data-id="element-106" data-mp="1j6dg1z8q16yz">
          <p data-id="element-107" data-mp="1ebr3hsqwl8db">Accedé y explorá todo el material con tranquilidad.</p>
          <p data-id="element-108" data-mp="qmycmap51qpk">
            Si dentro de los próximos 7 días considerás que no es lo que esperabas, podés solicitar
            el reembolso según las condiciones de garantía.
          </p>
        </div>

        <p className="mt-7 font-display text-xl font-bold text-plum-700" data-id="element-109" data-mp="oyqa7yjpzdee">
          Tu compra está protegida.
        </p>
      </div>
    </section>;
}